export default "__VITE_ASSET__66fdb261__"